export const getRating = (skills) => {
  let result = 0;
  Array.isArray(skills) &&
    skills.map((item) => {
      result = result + item?.rating;  
    });

  return parseFloat(result / skills.length).toFixed(2);
};
